import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let currentUser = this.authenticationService.currentUserValue;
        if (currentUser && currentUser.data.access_token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.data.access_token}`,
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            });
        }
        return next.handle(request);
    }
}